// Exports
export default {
	"nativeAppBanner": "nativeAppBanner_7l+kr",
	"appIcon": "appIcon_PpbmK",
	"appDetails": "appDetails_fYWzE",
	"appName": "appName_t7TRP",
	"appDescription": "appDescription_QC0NP"
};
